module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/booking.svg?3c8c9a3e";